{
  "familyId": "GET-PROC-VAN",
  "questions": [
    {
      "id": "GET-PROC-VAN-001",
      "familyId": "GET-PROC-VAN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "skill": "procenten",
      "subSkill": "proc_van_bedrag",
      "questionType": "ratio_table",
      "question": "Vul de tabel aan. Hoeveel is 30% van 150?",
      "context": null,
      "options": ["45", "50", "30", "15"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Percentage", "Bedrag"],
        "rows": [[10, 15], [30, null]],
        "missingCell": {"row": 1, "col": 1},
        "correctValue": 45,
        "hint": "Als 10% = 15, dan is 30% = 3 × 15"
      },
      "conceptId": "percentage_table_calculation",
      "variantIndex": 1,
      "group": 7,
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "headers": ["Percentage", "Bedrag"],
            "rows": [
              ["10%", "15"],
              ["30%", "?"]
            ],
            "label": "Verhoudingstabel: 10% van 150 = 15"
          }
        }
      ],
      "supportAids": [
        {
          "type": "ratio",
          "showWhen": "wrong",
          "data": {
            "headers": ["Percentage", "Bedrag"],
            "rows": [
              ["10%", "15"],
              ["30%", "45"]
            ],
            "highlight": [1, 1]
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 45. Stap 1: 10% van 150 = 150 ÷ 10 = 15. Stap 2: 30% = 3 × 10%, dus 3 × 15 = 45. De verhoudingstabel helpt: als 10% → 15, dan 30% → 3 × 15 = 45.",
        "distractorExplanations": {
          "0": "Goed! 10% van 150 = 15, dus 30% = 3 × 15 = 45.",
          "1": "50 is niet correct. Je hebt waarschijnlijk 150 ÷ 3 = 50 berekend, maar dat geeft 33%, niet 30%. Gebruik de tabel: 10% = 15, dus 30% = 3 × 15 = 45.",
          "2": "30 is het percentage zelf, niet het bedrag. Je moet 30% van 150 uitrekenen: 3 × 15 = 45.",
          "3": "15 is 10% van 150, niet 30%. Je hebt maar één stap gedaan. Vermenigvuldig nog met 3: 3 × 15 = 45."
        }
      }
    },
    {
      "id": "GET-PROC-VAN-002",
      "familyId": "GET-PROC-VAN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "skill": "procenten",
      "subSkill": "proc_van_bedrag",
      "questionType": "ratio_table",
      "question": "Een winkel geeft korting. Vul de tabel aan: 20% korting op €80 is?",
      "context": null,
      "options": ["€16", "€64", "€20", "€60"],
      "correctAnswer": 0,
      "data": {
        "headers": ["Korting", "Bedrag"],
        "rows": [[10, 8], [20, null]],
        "missingCell": {"row": 1, "col": 1},
        "correctValue": 16,
        "hint": "Als 10% = €8, dan is 20% = 2 × €8"
      },
      "conceptId": "percentage_discount_table",
      "variantIndex": 2,
      "group": 7,
      "stimulusAids": [
        {
          "type": "ratio",
          "data": {
            "headers": ["Korting", "Bedrag"],
            "rows": [
              ["10%", "€8"],
              ["20%", "?"]
            ],
            "label": "Verhoudingstabel: 10% van €80 = €8"
          }
        }
      ],
      "supportAids": [
        {
          "type": "ratio",
          "showWhen": "wrong",
          "data": {
            "headers": ["Korting", "Bedrag"],
            "rows": [
              ["10%", "€8"],
              ["20%", "€16"]
            ],
            "highlight": [1, 1]
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is €16. Stap 1: 10% van €80 = €80 ÷ 10 = €8. Stap 2: 20% = 2 × 10%, dus 2 × €8 = €16. De korting is €16 — niet het nieuwe bedrag.",
        "distractorExplanations": {
          "0": "Goed! 10% van €80 = €8, dus 20% = 2 × €8 = €16.",
          "1": "€64 is het bedrag na korting (€80 − €16 = €64), maar de vraag vraagt naar de korting zelf, niet het nieuwe bedrag. De korting is €16.",
          "2": "€20 klopt niet. Je hebt misschien €80 ÷ 4 = €20 berekend (= 25%), maar 20% van €80 is 2 × €8 = €16.",
          "3": "€60 is niet correct. Controleer je berekening: 10% van €80 = €8, en 20% = 2 × €8 = €16, niet €60."
        }
      }
    },
    {
      "id": "GET-PROC-VAN-003",
      "familyId": "GET-PROC-VAN",
      "module": "Getalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "skill": "procenten",
      "subSkill": "proc_van_bedrag",
      "questionType": "multiple_choice",
      "question": "Hoeveel is 25% van 200?",
      "context": null,
      "options": ["50", "25", "75", "100"],
      "correctAnswer": 0,
      "conceptId": "percentage_of_number",
      "variantIndex": 1,
      "group": 7,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "25% berekenen",
            "content": "25% = een kwart. Deel het getal door 4. Of: 10% berekenen en dan × 2,5. Hier: 200 ÷ 4 = 50."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 50. Stap 1: 25% = een kwart, dus 200 ÷ 4 = 50. Of via 10%: 10% van 200 = 20, dan 25% = 2 × 20 + 5% = 40 + 10 = 50.",
        "distractorExplanations": {
          "0": "Goed! 25% van 200 = 200 ÷ 4 = 50.",
          "1": "25 is het percentage zelf, niet het antwoord. Je moet 25% van 200 uitrekenen: 200 ÷ 4 = 50.",
          "2": "75 is niet correct. Je hebt misschien 200 − 25% berekend of een andere fout gemaakt. 25% van 200 = 50, niet 75.",
          "3": "100 is 50% van 200 (de helft). Maar 25% is een kwart, dus de helft van 100: 200 ÷ 4 = 50."
        }
      }
    }
  ]
}
